module.exports = __webpack_public_path__ + "static/media/16UNODC4.649abd23.jpg";